import * as Cookie from './cookie';

export default function initMunicipalitySelector() {
    const municipalitySelectors = document.querySelectorAll('[municipality-select-form]');

    municipalitySelectors.forEach((elem) => {
        elem.addEventListener('submit', (e) => {
            e.preventDefault();

            const selectedMunicipality = e.currentTarget.querySelector('[data-set-municipality]').value;

            if (selectedMunicipality) {
                Cookie.set('municipality', selectedMunicipality);

                e.currentTarget.submit();
            }
        });
    });
}
